import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Biology = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.087 42.088h-9.743c5.022-6.63 4.72-15.971-.904-22.3 1.104-1.506 1.104-3.515.2-5.022l3.918-3.918a.971.971 0 0 0 0-1.406l-1.005-1.004 3.215-3.215a.971.971 0 0 0 0-1.406L31.252.301a.971.971 0 0 0-1.406 0L26.63 3.516c-.703-.603-1.506-2.01-2.51-1.005L6.14 20.291a.97.97 0 0 0 0 1.406l.804.803c-1.105 1.507-1.005 3.717.401 5.023a3.84 3.84 0 0 0 5.023.402l.803.803a.971.971 0 0 0 1.407 0l7.835-7.835c1.406.904 3.114.904 4.52.1 5.324 6.028 5.223 15.068-.201 20.994H11.464V37.97h4.52c.502 0 1.004-.502 1.004-1.004s-.401-1.005-1.004-1.005H4.934c-.502 0-1.004.402-1.004 1.005 0 .502.402 1.004 1.005 1.004h4.62v4.018h-4.62c-1.306 0-1.306 2.01 0 2.01h34.152c1.306.1 1.306-1.91 0-1.91ZM30.55 2.31l2.11 2.11-2.512 2.51-2.11-2.108L30.55 2.31ZM8.752 26.217a1.833 1.833 0 0 1-.302-2.21l2.512 2.511a1.833 1.833 0 0 1-2.21-.301Zm12.857-12.255c-1.507 1.507-1.708 3.817-.603 5.625l-7.131 7.132-.704-.703-4.922-4.922L24.823 4.42c1.407 1.306 4.32 4.219 5.625 5.625l-3.214 3.214c-1.707-1.105-4.018-.803-5.625.703Zm3.214 5.726a2.487 2.487 0 0 1-2.51-2.511 2.487 2.487 0 0 1 2.51-2.511 2.487 2.487 0 0 1 2.512 2.51c0 1.307-1.105 2.512-2.512 2.512Z"
  }));
});
Biology.displayName = 'Biology';
Biology.defaultProps = {
  'aria-label': 'Biology'
};
export default Biology;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Biology.js
// module id = 3609
// module chunks = 11